import { useState } from 'react';
import { useLang } from '../../../context/LanguageContext';
import AnimatedSection from '../../../components/base/AnimatedSection';

function FAQItem({ q, a, idx }: { q: string; a: string; idx: number }) {
  const [open, setOpen] = useState(false);
  return (
    <div className={`border-b transition-colors duration-300 ${open ? 'border-red-600/40' : 'border-zinc-800'}`}>
      <button onClick={() => setOpen(!open)} className="w-full flex items-center justify-between py-5 text-left gap-4 cursor-pointer group">
        <div className="flex items-center gap-5">
          <span className={`relative flex-shrink-0 w-8 h-8 flex items-center justify-center rounded-full text-xs font-black font-mono transition-all duration-300 ${
            open
              ? 'bg-red-600 text-white shadow-[0_0_12px_rgba(220,38,38,0.5)]'
              : 'bg-zinc-900 border border-zinc-700 text-zinc-600 group-hover:border-red-600/40 group-hover:text-red-500'
          }`}>
            {String(idx + 1).padStart(2, '0')}
          </span>
          <span className={`text-sm font-semibold transition-colors leading-snug ${open ? 'text-white' : 'text-zinc-300 group-hover:text-white'}`}>{q}</span>
        </div>
        <div className={`w-7 h-7 flex-shrink-0 flex items-center justify-center rounded-full border transition-all duration-300 ${open ? 'border-red-600 bg-red-600/10 rotate-45' : 'border-zinc-700 bg-zinc-900 group-hover:border-zinc-500'}`}>
          <i className={`ri-add-line text-sm transition-colors ${open ? 'text-red-400' : 'text-zinc-400'}`} />
        </div>
      </button>
      <div style={{
        maxHeight: open ? '400px' : '0',
        overflow: 'hidden',
        opacity: open ? 1 : 0,
        transition: 'max-height 0.45s cubic-bezier(0.16,1,0.3,1), opacity 0.3s ease',
      }}>
        <p className="text-zinc-400 text-sm leading-relaxed pb-6 pl-13" style={{ paddingLeft: '3.25rem' }}>{a}</p>
      </div>
    </div>
  );
}

export default function FAQSection() {
  const { t } = useLang();
  const faqs = [
    { q: t('faq_q1'), a: t('faq_a1') }, { q: t('faq_q2'), a: t('faq_a2') },
    { q: t('faq_q3'), a: t('faq_a3') }, { q: t('faq_q4'), a: t('faq_a4') },
    { q: t('faq_q5'), a: t('faq_a5') }, { q: t('faq_q6'), a: t('faq_a6') },
    { q: t('faq_q7'), a: t('faq_a7') }, { q: t('faq_q8'), a: t('faq_a8') },
  ];
  return (
    <section className="w-full bg-zinc-950 py-24 px-6 always-dark" id="faq">
      <div className="max-w-screen-xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-16">
          <AnimatedSection>
            <div className="lg:sticky lg:top-24">
              <span className="inline-block text-red-500 text-[10px] font-extrabold uppercase tracking-widest mb-4">{t('faq_badge')}</span>
              <h2 className="text-white text-3xl md:text-4xl font-extrabold uppercase tracking-wider mb-6 leading-tight">
                {t('faq_title_1')}<br /><span className="text-red-500">{t('faq_title_2')}</span>
              </h2>
              <p className="text-zinc-400 text-sm leading-relaxed mb-8">{t('faq_subtitle')}</p>
              <a href="#contacto" onClick={(e) => { e.preventDefault(); document.querySelector('#contacto')?.scrollIntoView({ behavior: 'smooth' }); }}
                className="inline-flex items-center gap-2 text-red-500 hover:text-red-400 text-xs font-extrabold uppercase tracking-widest transition-colors cursor-pointer group">
                {t('faq_more')} <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform" />
              </a>
            </div>
          </AnimatedSection>
          <AnimatedSection className="lg:col-span-2">
            <div>{faqs.map((faq, i) => <FAQItem key={i} q={faq.q} a={faq.a} idx={i} />)}</div>
          </AnimatedSection>
        </div>
      </div>
    </section>
  );
}